import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { PageHeader } from '../components/PageHeader';
import { ImpactSection } from '../components/ImpactSection';
import { TrustSection } from '../components/TrustSection';
import { Target, Users, Heart, BookOpen } from 'lucide-react';
export function ImpactPage() {
  const programAreas = [{
    icon: <BookOpen size={40} data-id="element-673" />,
    title: 'Education & Scholarships',
    description: 'Supporting underprivileged students with scholarships and educational resources to unlock their potential and build better futures.',
    color: 'bg-sfrr-blue'
  }, {
    icon: <Heart size={40} data-id="element-674" />,
    title: 'Healthcare Access',
    description: 'Expanding access to quality healthcare services through medical outreach programs and health education initiatives.',
    color: 'bg-sfrr-pink'
  }, {
    icon: <Users size={40} data-id="element-675" />,
    title: 'Women & Youth Empowerment',
    description: 'Providing skills training and economic opportunities to empower women and youth across Nigeria.',
    color: 'bg-sfrr-green'
  }, {
    icon: <Target size={40} data-id="element-676" />,
    title: 'Community Development',
    description: 'Working with communities to implement sustainable solutions that create lasting positive change.',
    color: 'bg-sfrr-yellow'
  }];
  return <div className="font-sans bg-warm-ivory min-h-screen w-full" data-id="element-677">
      <Header data-id="element-678" />
      <main className="w-full font-sans" data-id="element-679">
        <PageHeader title="Our Impact" subtitle="Transforming lives and building stronger communities across Nigeria" badgeText="IMPACT & PROGRAMS" bgColor="bg-gradient-to-r from-sfrr-pink to-sfrr-blue" data-id="element-680" />

        <ImpactSection data-id="element-681" />

        {/* Program Areas */}
        <section className="py-16 bg-white" data-id="element-682">
          <div className="container mx-auto px-4" data-id="element-683">
            <div className="text-center mb-12" data-id="element-684">
              <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-685">
                Our Program Areas
              </h2>
              <p className="max-w-2xl mx-auto text-gray-600" data-id="element-686">
                We focus on strategic initiatives that address the root causes
                of poverty and create sustainable pathways to prosperity.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-687">
              {programAreas.map((program, index) => <div key={index} className="bg-warm-ivory rounded-2xl p-8 shadow-soft hover:shadow-hover transition-all duration-300 hover:-translate-y-1" data-id="element-688">
                  <div className={`w-16 h-16 rounded-xl ${program.color} bg-opacity-10 flex items-center justify-center mb-6`} data-id="element-689">
                    <div className={`${program.color.replace('bg-', 'text-')}`} data-id="element-690">
                      {program.icon}
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-charcoal mb-3" data-id="element-691">
                    {program.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-692">
                    {program.description}
                  </p>
                </div>)}
            </div>
          </div>
        </section>

        {/* Our Approach */}
        <section className="py-16 bg-warm-ivory" data-id="element-693">
          <div className="container mx-auto px-4" data-id="element-694">
            <div className="max-w-3xl mx-auto" data-id="element-695">
              <h2 className="text-2xl md:text-3xl font-bold text-charcoal mb-6 text-center" data-id="element-696">
                Our Approach to Creating Impact
              </h2>
              <div className="space-y-6" data-id="element-697">
                <div className="bg-white rounded-xl p-6 shadow-soft" data-id="element-698">
                  <h3 className="text-xl font-bold text-sfrr-green mb-3" data-id="element-699">
                    Community-Centered Design
                  </h3>
                  <p className="text-gray-600" data-id="element-700">
                    We work directly with communities to understand their needs
                    and co-create solutions that are sustainable and culturally
                    appropriate.
                  </p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-soft" data-id="element-701">
                  <h3 className="text-xl font-bold text-sfrr-pink mb-3" data-id="element-702">
                    Strategic Partnerships
                  </h3>
                  <p className="text-gray-600" data-id="element-703">
                    We collaborate with local organizations, government
                    agencies, and other stakeholders to maximize our impact and
                    ensure program sustainability.
                  </p>
                </div>
                <div className="bg-white rounded-xl p-6 shadow-soft" data-id="element-704">
                  <h3 className="text-xl font-bold text-sfrr-blue mb-3" data-id="element-705">
                    Transparency & Accountability
                  </h3>
                  <p className="text-gray-600" data-id="element-706">
                    We maintain the highest standards of financial transparency
                    and program accountability, ensuring donor funds are used
                    effectively and efficiently.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <TrustSection data-id="element-707" />
      </main>
      <Footer data-id="element-708" />
    </div>;
}